import { useNavigate } from "react-router-dom";
import { ACROSS_LOGO } from "../../../../assets";

import "./index.scss";

const Header = () => {
  const navigate = useNavigate();

  return (
    <div className="check-status-header">
      <div className="check-status-header__logo-container">
        <img
          alt="Across Logo"
          src={ACROSS_LOGO}
          className="check-status-header__logo"
        />
      </div>

      <div className="check-status-header__actions">
        <button
          className="check-status-header__btn check-status-header__btn--border"
          onClick={() => navigate("/download-certificate")}
        >
          Download Certificate
        </button>

        <button
          className="check-status-header__btn"
          onClick={() => navigate("/admin-signin")}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Header;
